import React from 'react';
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Spinner } from 'components/UI';
import { CHANNEL_COLORS, SourceRow } from '../../data/mockData';
import styles from './ClientsBySourceBarChart.module.scss';

interface ClientsBySourceBarChartProps {
    rows: Array<SourceRow>;
    loading: boolean;
}

export const ClientsBySourceBarChart: React.FC<ClientsBySourceBarChartProps> = props => {
    if (props.loading) {
        return (
            <div className={styles.loadingWrap}>
                <Spinner />
            </div>
        );
    }

    const data = props.rows.map(row => ({
        name: row.source.name,
        bucket: row.source.bucket,
        clients: row.newClients
    }));

    return (
        <ResponsiveContainer
            width="100%"
            height={Math.max(260, data.length * 42)}
        >
            <BarChart
                data={data}
                layout="vertical"
                margin={{ top: 8, right: 24, bottom: 8, left: 8 }}
            >
                <CartesianGrid
                    horizontal={false}
                    stroke="#F1F1F1"
                />
                <XAxis
                    type="number"
                    allowDecimals={false}
                    tick={{ fontSize: 12, fontFamily: 'Poppins' }}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    type="category"
                    dataKey="name"
                    width={190}
                    tick={{ fontSize: 12, fontFamily: 'Poppins' }}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip
                    cursor={{ fill: '#FAFAFA' }}
                    formatter={(value: number) => [`${value} new clients`, '']}
                    separator=""
                    contentStyle={{ fontFamily: 'Poppins', fontSize: 12, borderRadius: 8 }}
                />
                <Bar
                    dataKey="clients"
                    radius={[0, 6, 6, 0]}
                    barSize={18}
                >
                    {data.map(entry => (
                        <Cell
                            key={entry.name}
                            fill={CHANNEL_COLORS[entry.bucket]}
                        />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default ClientsBySourceBarChart;
